import Header from "./Header";
import HeaderChild from "./HeaderChild";

const HeaderMobile = ({ header, showIcon }) => {
  const elemet = {
    headerChild: HeaderChild,
  };

  const HeaderComponent = header.headerType
    ? elemet[header.headerType]
    : Header;

  return (
    <HeaderComponent
      showIcon={showIcon}
      headerTitle={header.headerTitle}
      handleBack={header.handleBack}
    />
  );
};

export default HeaderMobile;
